import {ColonistGiftMembershipProduct} from '../../../../../shared/store/ColonistGiftMembershipProduct'
import {UIStoreMembershipProductView} from '../UIStoreMembershipProductView'
import {UIStoreState} from '../UIStoreState'
import {createHeaderIn, createParagraphIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {ClientUserState} from '../../ClientUserState'
import {TranslationObject} from '@colonist/i18n'

export class UIStoreGiftMembershipProductView extends UIStoreMembershipProductView {
    constructor(parentDiv: HTMLDivElement, storeState: UIStoreState, product: ColonistGiftMembershipProduct) {
        super(parentDiv, storeState, product)
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.select'})
        this.subscribeButtonText.style.marginBottom = '0'
        this.setPrice(product.getDefaultPrice())
        this.subscribeButton.classList.add('button-select')
    }

    select() {
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.selected'})
        this.productDiv.classList.add('selected')
        this.subscribeButton.classList.add('selected')
    }

    deselect() {
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.select'})
        this.productDiv.classList.remove('selected')
        this.subscribeButton.classList.remove('selected')
    }

    setPrice(price: string) {
        setElementInnerHTML(this.priceDiv, {key: 'strings:colonistCommon.utils.emptyString'})
        this.membershipPrice = createHeaderIn(this.priceDiv, {key: 'strings:colonistCommon.utils.emptyString'}, '', '', 'H1')
        setElementInnerHTML(this.membershipPrice, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `${price}`}})
        this.disclaimerText.replaceChildren()
    }

    protected override addBestValueHint() {
        if(!this.membershipProduct.bestValue) return

        const shouldShowMostPopularText = ClientUserState.abTests.GIFTING_CHANGE_BEST_VALUE_HINT == 'SHOW_MOST_POPULAR'
        const hintText: TranslationObject = shouldShowMostPopularText ? {key: 'strings:storePage.mostPopular'} : {key: 'strings:storePage.bestValue'}
        this.productDiv.classList.add('store_page_membership_best_value_border')
        createParagraphIn(this.headerDiv, hintText, 'store_page_membership_best_value_banner')
    }
}
